var sb = require('@sb/util')
var config = require('@sb/config')

export default {
	name: 'ImageAttachment',
	props: ['ev'],

	render () {
		var attachments = sb.get(this.ev, 'data.message.attachments', [])
		var images = []
		let byType = sb.get(this.ev, 'by.type')

		sb.each(attachments, (att, i) => {
			if (!att) return
			if (!sb.includes(att.mimetype, 'image')) return
			if (!att.url) return

			var uri = att.url
			if (
				!uri.startsWith('https://') &&
				!uri.startsWith('http://') &&
				!uri.startsWith('content://') &&
				!uri.startsWith('data:')
			) {
				att.url = config.FileURL + uri
			}
			images.push(att)
		})

		if (images.length === 0) return null

		var $images = sb.map(images, (image, index) => (
			<div class={`image-attachment image-attachment--${byType}`}>
				<a href={sb.replaceFileUrl(image.thumbnail_url || image.url)} target="_blank">
					<img
						class="image-attachment__img"
						src={sb.replaceFileUrl(image.thumbnail_url || image.url)}
						onload={this.onLoad}
					/>
				</a>
			</div>
		))

		if (byType === 'agent') {
			return <div class="message-agent">{$images}</div>
		} else {
			return <div class="message-user">{$images}</div>
		}
	},
	methods: {
		onLoad () {
			this.$emit('loaded')
		},
	},
}
